import epsClient from 'enrollment-platform/api/eps.client'
import {
  parseContentDispositionFilename,
  saveBlobToDisk,
} from 'enrollment-platform/pages/finance/utils/blob-download'
import { AncillaryReport } from './ancillary-report.types'

const PATH = '/api/v1/ancillary-reports'

export const fetchAncillaryReport = async (
  clientPublicKey: string
): Promise<AncillaryReport> => {
  const { data } = await epsClient.get<AncillaryReport>(PATH, {
    params: { clientPublicKey },
  })
  return data
}

/**
 * The clients the caller may open the report for, from `clientPublicKeys` or,
 * when omitted, from every client whose Noyo snapshot is enabled. EPS applies
 * the per-customer client-admin configuration.
 */
export const fetchOpenableAncillaryReportClients = async (
  clientPublicKeys?: string[]
): Promise<string[]> => {
  if (clientPublicKeys?.length === 0) return []
  const { data } = await epsClient.get<{ clientPublicKeys: string[] }>(
    `${PATH}/clients`,
    {
      params: clientPublicKeys
        ? { clientPublicKeys: clientPublicKeys.join(',') }
        : undefined,
    }
  )
  return data.clientPublicKeys
}

export const downloadAncillaryReport = async (
  clientPublicKey: string
): Promise<void> => {
  const response = await epsClient.get<Blob>(PATH, {
    params: { clientPublicKey, format: 'xlsx' },
    responseType: 'blob',
  })
  const fileName =
    parseContentDispositionFilename(
      response.headers['content-disposition'] as string | undefined
    ) ?? 'ancillary-report.xlsx'
  saveBlobToDisk(response.data, fileName)
}

export const assignAncillaryDiscrepancy = async (input: {
  clientPublicKey: string
  benefitIds: string[]
  assignee: string | null
}): Promise<void> => {
  await epsClient.patch(`${PATH}/assignee`, input)
}

export const triggerAncillarySnapshot = async (): Promise<{
  status: 'queued'
  jobId: string
}> => {
  const { data } = await epsClient.post<{ status: 'queued'; jobId: string }>(
    `${PATH}/snapshot`
  )
  return data
}
